// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px){
  #prayHands{
    display: none;
  }
}
#contactHelp{
  color: white;
}
.InputField, .msgArea{
  margin: 10px;
}
.msgArea{
  display: flex;
  flex-direction: column;
}
.grouped{
  display: flex;
  background-color: rgb(24, 75, 125);
  justify-content: space-evenly;
}
.grouped2{
  display: flex;
  background-color: rgb(24, 75, 125);
  flex-direction: column;
}
.MapBox, .MapBox th, .MapBox td{
  width: fit-content;
  color: white;
  border: 3px solid gold;
}
th{
  padding: 7px;
}
.Boxes {
  float: right;
}
label{
    color: antiquewhite;
}
#prayHands{
  width: 40%;
  height: 562px;
}
.radioGroup {
    margin: 15px 0; 
    display: flex; 
    flex-direction: column; 
    gap: 5px; 
    align-items: flex-start;
}
.fa-map-marker {
  background: rgba(255, 217, 0, 0.842);
  color: white;
}
.fa-map-pin {
  background: rgba(255, 217, 0, 0.842);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Contact.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;IACI,mBAAmB;AACvB;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;AACd","sourcesContent":["@media (max-width: 768px){\n  #prayHands{\n    display: none;\n  }\n}\n#contactHelp{\n  color: white;\n}\n.InputField, .msgArea{\n  margin: 10px;\n}\n.msgArea{\n  display: flex;\n  flex-direction: column;\n}\n.grouped{\n  display: flex;\n  background-color: rgb(24, 75, 125);\n  justify-content: space-evenly;\n}\n.grouped2{\n  display: flex;\n  background-color: rgb(24, 75, 125);\n  flex-direction: column;\n}\n.MapBox, .MapBox th, .MapBox td{\n  width: fit-content;\n  color: white;\n  border: 3px solid gold;\n}\nth{\n  padding: 7px;\n}\n.Boxes {\n  float: right;\n}\nlabel{\n    color: antiquewhite;\n}\n#prayHands{\n  width: 40%;\n  height: 562px;\n}\n.radioGroup {\n    margin: 15px 0; \n    display: flex; \n    flex-direction: column; \n    gap: 5px; \n    align-items: flex-start;\n}\n.fa-map-marker {\n  background: rgba(255, 217, 0, 0.842);\n  color: white;\n}\n.fa-map-pin {\n  background: rgba(255, 217, 0, 0.842);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
